export const normalizeQuickLinksData = ({ slotData, mediaCollectionIndex = 0 }) => {

  if (slotData?.slot) {
    const { slot } = slotData;
    const mediaCollections = slot.mediaCollections || [];
    const fallbackMediaCollection = mediaCollections[0] || null;
    const mediaCollection = mediaCollections[mediaCollectionIndex] || fallbackMediaCollection;
    const media = mediaCollection?.media || [];

    const linkList = media.map((item) => ({
      id: item.entryId,
      label: item.title || '',
      href: item.sourceDesktop?.[0]?.hyperlink || item.sourceMobile?.[0]?.hyperlink || '',
    }));
    return {
      linkList,
    };
  }
  return null;
};

export default normalizeQuickLinksData;
